import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { Scanner } from '@yudiel/react-qr-scanner';

export default function BarCodeScanner({open, onClose, title = 'Barcode Scanner', onScan = null }) {

    const handleClose = () => {
        onClose();
    };

    const handleScan = (result) => {
      onScan(result);
      handleClose();
    };

    return (
        <React.Fragment>

        <Dialog onClose={handleClose} open={open} disableRestoreFocus>
            <DialogTitle>
            {title}
            </DialogTitle>
            <DialogContent
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",     // horizontal centering
                justifyContent: "center", // vertical centering
              }}
            >
              <Scanner
                onScan={handleScan}
                onError={(error) => console.log(error?.message)}
              />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Close</Button>
            </DialogActions>
        </Dialog>
        </React.Fragment>
    );
}